import { useMemo } from 'react';
import { useSingleSettings } from '@/data/Settings';
import getValueByPathFromUnknown from '../../../utils/getValueByPathFromUnknown';
import valueIsString from '../../../utils/typeAssertions/valueIsString';

export const useGoogleOauthClientId = () => {
	const { settings: singleSettings, loading: loadingGoogleOauthClientId } = useSingleSettings();

	const googleOauthClientId = useMemo(() => {
		const userData = singleSettings?.userData || {};
		const value = getValueByPathFromUnknown(userData, ['google_oauth_clientid']);
		return valueIsString(value) ? value : null;
	}, [singleSettings?.userData]);

	return { googleOauthClientId, loadingGoogleOauthClientId };
};
